import imageQuizPreviewEmptyState from '@/assets/buzz/buzz-question-preview-empty-state.png';
import imageQuizPreviewBottombar from '@/assets/buzz/quiz_preview_bottombar.png';
import { QuizQuestionForm } from '@/models/QuizQuestion';
import PerfectScrollbar from 'perfect-scrollbar';
import React,{ useEffect,useRef,useState } from 'react';
import _ from 'underscore';
import './style.scss';

interface Props {
    formState: QuizQuestionForm;
    imageTempPath?: string;
}

const QuizQuestionPreviewScreen: React.FC<Props> = (props: Props) => {
    const { description, image, options } = props.formState;
    const { imageTempPath } = props;

    const quizRef = useRef<HTMLDivElement | null>(null);
    const [perfectScrollbar, setPerfectScrollbar] = useState<PerfectScrollbar>();

    const formIsEmpty = _.isEmpty(image) && _.isEmpty(description) && !options.some((op) => Boolean(op.description.trim()));

    const updatePerfectScrollbar = () => {
        perfectScrollbar && setTimeout(() => perfectScrollbar.update(), 500);
    };

    useEffect(() => {
        quizRef.current && setPerfectScrollbar(new PerfectScrollbar('#quiz-question-preview-container', { wheelPropagation: false }));
    }, [quizRef]);

    useEffect(() => updatePerfectScrollbar(), [image, description]);

    return (
        <div className="quiz-question-preview-container" id="quiz-question-preview-container" ref={quizRef}>
            <div className={`quiz-question-preview-content ${formIsEmpty ? 'empty-state' : ''}`}>
                {formIsEmpty ? (
                    <img className="quiz-question-preview" src={imageQuizPreviewEmptyState} />
                ) : (
                    <>
                        <div className="quiz-question-preview" id="quiz-question-preview">
                            {(!_.isEmpty(image) || !_.isEmpty(imageTempPath)) && (
                                <div className="preview-image">
                                    <img src={imageTempPath || image} />
                                </div>
                            )}
                        </div>
                        {!_.isEmpty(description) && <div className="quiz-question-description">{description}</div>}
                        <div className="quiz-question-answers">
                            {['left', 'right'].map((direction, index) => {
                                const { description } = options[index];

                                return (
                                    !_.isEmpty(description) && (
                                        <div className={`quiz-question-answer ${direction}`} key={`quiz-question-answer-${direction}`}>
                                            <span>{description}</span>
                                        </div>
                                    )
                                );
                            })}
                        </div>
                    </>
                )}
            </div>
            <div className="quiz-question-preview-bottombar">
                <img src={imageQuizPreviewBottombar}></img>
            </div>
        </div>
    );
};

export default QuizQuestionPreviewScreen;
